import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { authCacheTags } from 'modules/auth/authCacheTags';
import { stakeCacheTags } from 'modules/stake/stakeCacheTags';

export const mainApi = createApi({
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: '',
  }),
  endpoints: () => ({}),
  reducerPath: 'mainApi',
  tagTypes: [...Object.values(authCacheTags), ...Object.values(stakeCacheTags)],
});
